import React from "react";
import UlLi, {scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import Highlight from "react-highlight";
import { Navigation, Link } from "react-router";
import UserHandler from "js/utilities/user-handler";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import ApptokenDisplay from "js/utilities/get-display-apptoken";
import { ZOOM_ICON } from "js/config.jsx";
import SDKSidebar from "js/utilities/sdk-sidebar";

import ENCRYPTION_KEYS_SWIFT from "resources/code/ios/encryption-keys.swift.tpl";
import ENCRYPTION_KEYS_OBJC from "resources/code/ios/encryption-keys.m.tpl";
import ENCRYPTION_KEY_JAVA from "resources/code/hybrid/android/07-set-encryption-key.java.tpl";
import ENCRYPTION_KEY_JAVA_SERVER from "resources/code/ios/encryption-keys.java.tpl";
import ENCRYPTION_KEY_JS from "resources/code/ios/encryption-keys.js.tpl";

import SDK_INITIALIZE_DEV_SWIFT from "resources/code/quickstart/ios/00-initialize-dev.swift.tpl";
import SDK_INITIALIZE_PROD_SWIFT from "resources/code/quickstart/ios/00-initialize-prod.swift.tpl";
import SDK_INITIALIZE_DEV_OBJC from "resources/code/quickstart/ios/00-initialize-dev.m.tpl";
import SDK_INITIALIZE_PROD_OBJC from "resources/code/quickstart/ios/00-initialize-prod.m.tpl";
import SDK_INITIALIZE_DEV_JAVA from "resources/code/quickstart/android/00-initialize-dev.java.tpl";
import SDK_INITIALIZE_PROD_JAVA from "resources/code/quickstart/android/00-initialize-prod.java.tpl";
import SDK_INITIALIZE_DEV_JS from "resources/code/quickstart/web/00-initialize-dev.js.tpl";
import SDK_INITIALIZE_PROD_JS from "resources/code/quickstart/web/00-initialize-prod.js.tpl";
import SERVER_SDK_INITIALIZE_DEV_JAVA from "resources/code/quickstart/server/00-initialize-dev.java.tpl";
import SERVER_SDK_INITIALIZE_PROD_JAVA from "resources/code/quickstart/server/00-initialize-prod.java.tpl";

import SDK_IMPORT_SWIFT from "resources/code/quickstart/ios/01-import.swift.tpl";
import SDK_IMPORT_OBJC from "resources/code/quickstart/ios/01-import.m.tpl";
import SDK_START_ENROLLMENT_SWIFT from "resources/code/quickstart/ios/02-start-enrollment.swift.tpl";
import SDK_START_ENROLLMENT_OBJC from "resources/code/quickstart/ios/02-start-enrollment.m.tpl";
import ON_BEFORE_DISMISS_SWIFT from "resources/code/ios/37-exit-animations.swift.tpl";
import ON_BEFORE_DISMISS_OBJC from "resources/code/ios/37-exit-animations.m.tpl";


export default React.createClass({
  displayName: "ios-guide",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var data  = [
        ];

    var scrollToElement = initDeepLinkData(this.props);

    return {
      data: data,
      navMenuParent: null,
      navMenu: null,
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container">
              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="keys">Device and Server SDK Keys</h2>
                </div>
                <p>This guide discusses the FaceTec SDK Key system.  SDK Keys are involved in FaceMap Encryption & Decryption, protecting your FaceMaps from use in other Apps.</p>
                <hr/>
              </section>

              <section>
                <h3 id="overview">Overview</h3>
                <p>Initializing FaceTec SDKs in Development Mode with a Development Key performs the important task of <strong>validating your Keys by making a network request to FaceTec Servers.</strong> This key validation mechanism is required during initial Development until a commercial agreement is in place.</p>
                <p>Many organizations do not allow their Production backend servers to make outgoing network requests for Security & Privacy reasons.  To mitigate this concern, FaceTec Production Keys allow the FaceTec Device and Server SDKs to operate in a mode that makes <strong>no network requests</strong> to FaceTec Servers.</p>
                <hr />
              </section>


              <section>
                <h3 id="types">Key Types</h3>
                <p><strong>FaceTec Development (HTTPS) Keys:</strong> <span style={{color:"red"}}>(Not For Production!)</span></p>
                <ul>
                  <li><p>Perform HTTPS network calls to FaceTec Servers.</p></li>
                  <li><p>Are validated using <code>ZoomSDK.initialize()</code>.</p></li>
                  <li><p>Usage Logs are transmitted over HTTPS automatically.</p></li>
                </ul>
                <p><strong>FaceTec Production Keys:</strong></p>
                <ul>
                  <li><p>Make <strong>NO</strong> network calls to FaceTec Servers.</p></li>
                  <li><p>Are validated using <code>ZoomSDK.initializeWithLicenseText()</code>.</p></li>
                  <li><p><Link to="usage-logs">Usage Logs are transmitted over SFTP and configured by the developer.</Link></p></li>
                  <li><p>Are involved in FaceMap Encryption & Decryption and are rotated automatically when FaceTec generates new Keys.</p></li>
                </ul>
              </section>

              <hr />

              <section>
                <h3 id="integrating-production">Integrating Production Keys</h3>
                <p><strong><span style={{color:"red"}}><u>DO NOT</u></span></strong> hard code your FaceTec Keys into the <code>initializeWithLicense</code> API in your Apps.  Instead, serve FaceTec Keys from an API or dynamic file that you pass into the <code>initializeWithLicense</code> API in your Apps.  This way, you will not need to compile your client or server code when you update your FaceTec Keys.</p>
                <p>This is <strong><span style={{color:"red"}}><u>CRITICAL</u></span></strong> because when your Production Keys are renewed, you should not have to update your client-side code and this will allow Production Key renewal to occur in a matter of minutes of dev work.</p>
              </section>

              <hr />

              <section>
                <h3 id="key-encryption">Key Security</h3>
                <blockquote><p><strong>Important Feature</strong>:  Because encryption involves aspects of your SDK Keys, FaceMaps from your App <strong>CANNOT BE</strong> used in other Apps!  This means that even if one of your FaceMaps is exposed it is not immediately usable in other Apps, even if your Private FaceMap Encryption Key is compromised.</p></blockquote>
                <p><strong><span style={{color:"red"}}><u>Production Keys MUST be rotated</u></span></strong> because they are involved in the low-level encryption and decryption mechanism for your App. This is <strong><span style={{color:"red"}}><u>CRITICAL</u></span></strong> for the security of your App!</p>
              </section>

              <hr />

              <section>
                <h3 id="parts">Key Parts</h3>
                <h4 id="device-key-identifier">Device Key Identifier</h4>
                <p>This is a unique key for your application.  This is the only piece of data needed to initialize FaceTec in <strong>Development Mode</strong>, but is also needed as a part of initializing in <strong>Production Mode</strong>.  In <strong>Production Mode</strong>, you also need your FaceTec Production Keys text in order to initialize successfully.  The Device Key Identifier is used for:</p>
                <ul>
                  <li><p>Initializing the FaceTec Device SDKs.</p></li>
                  <li><p>Initializing FaceTec Server.</p></li>
                  <li><p>Communicating with the FaceTec Testing API.</p></li>
                  <li><p>Telling FaceTec which application you are referring to when <Link to="/submitting-a-good-bug">Submitting a Bug</Link>.</p></li>
                </ul>
                <blockquote>
                  <p><strong>Important</strong>: The Device Key Identifier, Server Key, and FaceTec Key Text are bound together and can be accessed from your <Link to="/account">Account Page</Link>. Because SDK Keys are involved in the encryption/decryption process, key mismatches between client and server is one likely cause of "FaceMap could not be decrypted" issues.</p>
                </blockquote>
                <hr />

                <h4 id="server-key">Server Key</h4>
                <p>This is a unique <strong>private</strong> key needed for initialization for your FaceTec Server instances.  This data is needed to initialize FaceTec in both <strong>Development and Production Modes</strong>. In <strong>Production Mode</strong>, you also need your FaceTec Production Key text in order to initialize successfully.  The Server Key is used for:</p>
                <ul>
                  <li>Initializing FaceTec Server.</li>
                </ul>
                <blockquote>
                  <p><strong>Important</strong>: The Device Key Identifier, Server Key, and FaceTec Key Text are bound together and can be accessed from your <Link to="/account">Account Page</Link>. Because keys are involved in the encryption/decryption process, key mismatches between client and server is one likely cause of "FaceMap could not be decrypted" issues.</p>
                </blockquote>
                <hr />

                <h4 id="production-key-text-file">FaceTec Production Key Text</h4>
                <p>This is text (available as a file download from your <Link to="/account">Account Page</Link>).  This text is cryptographically verified against your Device Key Identifier and/or Server Key during initialization.  Usage of FaceTec Key Text allows FaceTec SDKs to operate in a mode that does not require a network call to FaceTec Servers in order to function.  Your FaceTec Production Keys are:</p>
                <ul>
                  <li><p>Needed for Initializing the FaceTec Device SDKs In Production.</p></li>
                  <li><p>Needed for Initializing FaceTec Server In Production.</p></li>
                  <li><p><strong>Rotated to ensure the Security of your App and initially issued for relatively short durations to ensure your App is configured correctly when initially Going Production.</strong></p></li>
                </ul>
                <blockquote>
                  <p><strong>Important</strong>: The Device Key Identifier, Server Key, and FaceTec Encryption Key Text are bound together and can be accessed from your <Link to="/account">Account Page</Link>. Because keys are involved in the encryption/decryption process, key mismatches between client and server is one likely cause of "FaceMap could not be decrypted" issues.</p>
                </blockquote>
                <hr />
             </section>

             <section>
                <h3 id="initialize-device-sdks">Initialization (Device SDKs)</h3>
                <p>Here is how you initialize the FaceTec Device SDKs using your initial Development Keys.</p>
                <div className="code-container">
                  <CodeBlocks swift={SDK_INITIALIZE_DEV_SWIFT()} objC={SDK_INITIALIZE_DEV_OBJC()} java={SDK_INITIALIZE_DEV_JAVA()} js={SDK_INITIALIZE_DEV_JS()} />
                </div>

                <p>Here is how you initialize the FaceTec Device SDKs with your <Link to="/going-production-overview">Production Keys</Link>.</p>
                <div className="code-container">
                  <CodeBlocks swift={SDK_INITIALIZE_PROD_SWIFT()} objC={SDK_INITIALIZE_PROD_OBJC()} java={SDK_INITIALIZE_PROD_JAVA()} js={SDK_INITIALIZE_PROD_JS()} />
                </div>
                <p></p>
             </section>

             <section>
                <h3 id="initialize-server-sdks">Initialization (Server SDKs)</h3>
                <p>Here is how you initialize the FaceTec Server SDKs using your initial Development Keys.</p>
                <div className="code-container">
                  <CodeBlocks java={SERVER_SDK_INITIALIZE_DEV_JAVA()}/>
                </div>
                <p>Here is how you initialize the FaceTec Server SDKs with your <Link to="/going-production-overview">Production Keys</Link>:</p>
                <div className="code-container">
                  <CodeBlocks java={SERVER_SDK_INITIALIZE_PROD_JAVA()}/>
                </div>
                <p></p>
             </section>

            <hr />

           

          </div>

          <SDKSidebar menuType="main" title="Encryption Keys"/>

        </div>
      </div>
    </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/keys.jsx